import { Box, Text, Flex, Image, useColorModeValue, Center, Heading } from '@chakra-ui/react';
// import { Center, Heading } from '@chakra-ui/react/dist';
import GitHubCalendar from 'react-github-calendar';

const GitHubStats = () => {
  return (
    <Box bg={useColorModeValue('#16325B', 'gray.900')} color="white" p={4} borderRadius="md" boxShadow="lg" id='github' box-shadow= {'rgba(0, 0, 0, 0.24) 0px 3px 8px;'} >
      <Text fontSize="xl" mb={4}>
        📊 GitHub Stats:
      </Text>
      <Flex flexWrap="wrap" justifyContent="center" alignItems="center"  mb={4}>
        <Image
          src="https://github-readme-stats.vercel.app/api/top-langs?username=deepak1181&show_icons=true&locale=en&layout=compact"
          alt="GitHub Stats"
          borderRadius="md"
          border="2px solid #3182CE"
          boxShadow="md"
        />
      </Flex>
      <Flex flexWrap="wrap" justifyContent="center" alignItems="center" mb={4}>
        <Image
          src="https://github-readme-stats.vercel.app/api?username=deepak1181&show_icons=true&locale=en"
          alt="GitHub Streak Stats"
          borderRadius="md"
          border="2px solid #3182CE"

          boxShadow="md"
        />
      </Flex>
      <Flex flexWrap="wrap" justifyContent="center" alignItems="center">
        <Image
          src="https://github-readme-streak-stats.herokuapp.com/?user=deepak1181&"
          alt="Top Languages"
          borderRadius="md"
          border="2px solid #3182CE"
          boxShadow="md"
        />
      </Flex>
      <Center mb={2} mt={4}>
        <Heading as="h1" color="white" fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}>GitHub Statistics</Heading>
      </Center>
      <Flex flexWrap="wrap" justifyContent="center" alignItems="center" >
      <GitHubCalendar width={"100%"}  fill={useColorModeValue('gray.100', 'gray.900')} style={{color: useColorModeValue('gray.100', 'gray.900'),  margin:"auto", padding:"20px"  }}  colorScheme={"light"}   username="deepak1181"  />
      </Flex>
    </Box>
  );
};

export default GitHubStats;
